import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const newActionTermsLink = getFeature('new-action-term-link') || 'https://blog.mail.ru/mail_space_sale/';
